import React, { useEffect, useRef, useState } from "react";
import "./index.css";
import {
  getAllEmployeeTasks,
  updateItem,
  getNestedItem,
  getNestedItemdualcondition,
  getSumofNestedItem,
  getSumofAllNestedItems,
  getgeneralNestedItemdualcondition,
} from "../../utils/firebasefunctions";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { arrayUnion } from "firebase/firestore";
import { useNavigate } from "react-router-dom";
import { useStateValue } from "../context/StateProvider";
import { actionType } from "../context/reducer";
import DatePicker from "react-datepicker";
import { RotatingLines } from "react-loader-spinner";
import "react-datepicker/dist/react-datepicker.css";
import { ToastContainer, toast } from "react-toastify";
import { TbCurrencyDollar } from "react-icons/tb";
import { IoCheckmarkCircle } from "react-icons/io5";
import { IoIosCloseCircle } from "react-icons/io";
import { MdEditDocument } from "react-icons/md";
import TimePicker from "react-time-picker";
import { MdDelete } from "react-icons/md";
import "react-time-picker/dist/TimePicker.css";
import { downloadExcel } from "react-export-table-to-excel";
import Switch from "react-switch";
import userlogo from "../images/user.png";
import moment from "moment";
import Select from "react-dropdown-select";
import {
  setKey,
  setDefaults,
  setLanguage,
  setRegion,
  fromAddress,
  fromLatLng,
  fromPlaceId,
  setLocationType,
  geocode,
  RequestType,
} from "react-geocode";
import { HiArrowDownLeft, HiArrowLeft } from "react-icons/hi2";
import { FaPlusCircle } from "react-icons/fa";
import { FaPlus } from "react-icons/fa6";
import ProjectPopUp from "../components/ProjectPopUp";
import Confirmationpopup from "../components/Confirmationpopup";
import UploadPaymentPopUp from "../components/UploadPaymentPopUp";

setDefaults({
  key: "AIzaSyBQITYyVOR2eVeTha4Vzfc2T8S0ZAcENDE", // Your API key here.
  language: "en", // Default language for responses.
  region: "es", // Default region for responses.
});

// import Section2 from '../components/Homesection/section2'
function HoursWorked() {
  const [
    {
      user,
      employees,
      jobs,
      clients,
      users,
      startdate,
      enddate,
      project,
      employeeid,
      employeedata,
    },
    dispatch,
  ] = useStateValue();
  const header = [
    "Hours Status",
    "Approved By",
    "Emp ID",
    "Name",
    "Project Title",
    "Designation",
    "Hourly Salary",
    "Check In",
    "Lunch In",
    "Lunch Out",
    "Check Out",
    "Total Break Time",
    "Total Time Of Day",
    "Vehicle Checkin Mileage (KM's)",
    "Vehicle Checkout Mileage (KM's)",
    "NORMAL HRS",
    "EVENING HRS",
    "NIGHT HRS",
    "HOURLY SALARY NORMAL",
    "HOURLY SALARY EVENING",
    "HOURLY SALARY NIGHT",
    "TOTAL SALARY",
    "INVOICING AMOUNT WITH A MULTIPLICATOR",
    "Fixed Amount",
    "Supervisor Note's",
  ];
  const holidayheader = [
    "Eployee ID",
    "Eployee Name",
    "Date",
    "Type",
    "Reason",
  ];
  const [excelBody, setExcelBody] = useState([]);

  const [searchtext, setsearchtext] = useState("");

  const [employeeprojects, setemployeeprojects] = useState([]);
  const [projectselectionpopup, setprojectselectionpopup] = useState(false);
  const [projectselectionpopup2, setprojectselectionpopup2] = useState(false);
  const [uploadpaymenttoggle, setuploadpaymenttoggle] = useState(false);

  const [generalemployeecheckindata, setgeneralemployeecheckindata] = useState(
    [],
  );
  const [todayshours, settodayshours] = useState(0);
  const [weeklyhours, setweeklyhours] = useState(0);
  const [monthlyhours, setmonthlyhours] = useState(0);
  const [alltimehours, setalltimehours] = useState(0);
  const [designation, setdesignation] = useState([]);
  const [filtertype, setfiltertype] = useState("Active");
  const [employeecheckindata, setemployeecheckindata] = useState([]);
  const [designationselectionpopup, setdesignationselectionpopup] =
    useState(false);
  const [loading, setloading] = useState(false);
  const [disableloader, setdisableloader] = useState(false);
  const [employeedeletionconfirmation, setemployeedeletionconfirmation] =
    useState(false);
  const [deleteloader, setdeleteloader] = useState(false);
  const navigate = useNavigate();

  // const designationselectionpopupref = useRef(null)

  // useEffect(() => {
  //   if (employees.length > 0) {

  //     dispatch({
  //       type: actionType.EMPLOYEEID,
  //       payload: employees[0].id,
  //     });

  //     dispatch({
  //       type: actionType.EMPLOYEEDATA,
  //       payload: employees[0],
  //     });
  //   }
  // }, []);

  useEffect(() => {
    if (employeeid != 0) {
      setprojectselectionpopup(false);
      // dispatch({
      //   type: actionType.STARTDATE,
      //   payload: new Date(new Date().setHours(0, 0, 0, 0)),
      // });
      // dispatch({
      //   type: actionType.ENDDATE,
      //   payload: new Date(new Date().setHours(23, 59, 59, 59)),
      // });
      dispatch({
        type: actionType.SELECTPROJECT,
        payload: "",
      });
      getallemployeejobs(employeeid);
      getallhoursdisplaydata();
    }
  }, [employeeid]);

  useEffect(() => {
    if (filtertype == "Active" || filtertype == "InActive") {
      gethours();
    }

    // else {
    //   getgeneralhours()
    // }
  }, [startdate, enddate, employeeid, project, filtertype]);

  // useEffect(() => {
  //   const handleClickOutside = (event) => {

  //     if (designationselectionpopupref.current && !designationselectionpopupref.current.contains(event.target)) {
  //       setdesignationselectionpopup(false);
  //     }

  //   };

  //   // Add event listener
  //   document.addEventListener('mousedown', handleClickOutside);

  //   // Cleanup event listener
  //   return () => {
  //     document.removeEventListener('mousedown', handleClickOutside);
  //   };
  // }, [ designationselectionpopupref]);

  const getlocationaddress = (lat, long) => {
    fromLatLng(lat, long)
      .then(({ results }) => {
        alert(results[0].formatted_address);
      })
      .catch(console.error);
  };

  const disableemployeetoggle = async (emp, bool) => {
    setdisableloader(true);
    let data = {
      disabled: bool,
    };

    if (bool) {
      data["diableddate"] = Date.now();
      data["disabledby"] = user.id;
    }

    await updateItem("users", emp.id, data)
      .then(async (response) => {
        if (bool) {
          toast.success(
            `${emp.firstname + " " + emp.lastname} disabled successfully!`,
          );
        } else {
          toast.success(
            `${emp.firstname + " " + emp.lastname} enabled successfully!`,
          );
        }
        let employeesdata = [...employees];
        const empindex = employeesdata.findIndex((item) => item.id === emp.id);
        employeesdata[empindex] = { ...employeesdata[empindex], ...data };

        dispatch({
          type: actionType.STORE_EMPLOYEES,
          payload: employeesdata,
        });

        dispatch({
          type: actionType.EMPLOYEEID,
          payload: employeesdata[empindex].id,
        });

        dispatch({
          type: actionType.EMPLOYEEDATA,
          payload: { ...employeesdata[empindex], ...data },
        });
        setdisableloader(false);
      })
      .catch((err) => {
        toast.warn(err);
        setdisableloader(false);
      });
  };

  const handlesearchChange = (event) => {
    setsearchtext(event.target.value);
  };
  const deleteeemployee = async (emp) => {
    setdeleteloader(true);
    let data = {
      delete: true,
      deletedate: Date.now(),
      deletedby: user.id,
    };

    await updateItem("users", emp.id, data)
      .then(async (response) => {
        toast.success(
          `${emp.firstname + " " + emp.lastname} deleted successfully!`,
        );
        let employeesdata = [...employees];
        const empindex = employeesdata.findIndex((item) => item.id === emp.id);
        employeesdata[empindex] = { ...employeesdata[empindex], ...data };

        dispatch({
          type: actionType.STORE_EMPLOYEES,
          payload: employeesdata,
        });

        dispatch({
          type: actionType.EMPLOYEEID,
          payload: employeesdata[empindex].id,
        });

        dispatch({
          type: actionType.EMPLOYEEDATA,
          payload: "",
        });
        setdeleteloader(false);
      })
      .catch((err) => {
        toast.warn(err);
        setdeleteloader(false);
      });
  };

  const updateemployeedata = async (param, bool, id) => {
    let data = {};
    data[param] = bool;
    if (param == "clientrole") {
      if (bool) {
        data["todolist"] = false;
        data["employeerole"] = false;
        data["vehiclecreationrole"] = false;
      } else {
        data["todolist"] = true;
      }
    }
    await updateItem("users", id, data)
      .then((response) => {
        if (response == "success") {
          const employeeindex = employees.findIndex((item) => item.id === id);
          let dataset = [...employees];
          dataset[employeeindex] = { ...dataset[employeeindex], ...data };
          dispatch({
            type: actionType.STORE_EMPLOYEES,
            payload: dataset,
          });

          dispatch({
            type: actionType.EMPLOYEEID,
            payload: dataset[employeeindex].id,
          });

          dispatch({
            type: actionType.EMPLOYEEDATA,
            payload: { ...dataset[employeeindex], ...data },
          });
        } else {
          toast.error("Something went wrong!. Please try again later.");
        }
      })
      .catch((err) => {
        alert(err);
      });
  };

  const getallhoursdisplaydata = () => {
    const currentDate = new Date();
    const startOfDay = new Date(currentDate);
    startOfDay.setHours(0, 0, 0, 0); // Set to the start of the current day
    const endOfDay = new Date(currentDate);
    endOfDay.setHours(23, 59, 59, 999); // Set to the end of the current day
    gethourssum(startOfDay.getTime(), endOfDay.getTime(), "day");
    const startOfWeek = new Date(currentDate);
    startOfWeek.setDate(startOfWeek.getDate() - currentDate.getDay()); // Sunday of the current week
    startOfWeek.setHours(0, 0, 0, 0); // Start of the day
    const endOfWeek = new Date(currentDate);
    endOfWeek.setDate(endOfWeek.getDate() + (6 - currentDate.getDay())); // Saturday of the current week
    endOfWeek.setHours(23, 59, 59, 999); // End of the day
    gethourssum(startOfWeek.getTime(), endOfWeek.getTime(), "week");
    const currentMonth = currentDate.getMonth();
    const currentYear = currentDate.getFullYear();
    const startOfMonth = new Date(currentYear, currentMonth, 1); // Start of the month
    const endOfMonth = new Date(currentYear, currentMonth + 1, 0); // End of the month
    gethourssum(startOfMonth.getTime(), endOfMonth.getTime(), "month");
    gethourssum();
  };

  const gethourssum = async (start, end, type) => {
    if (start != undefined && end != undefined && type != undefined) {
      await getSumofNestedItem(
        "slots",
        employeeid,
        "checkindatetime",
        ">=",
        start,
        "checkindatetime",
        "<=",
        end,
      )
        .then(async (response) => {
          if (type == "week") {
            setweeklyhours(parseInt(response / 60));
          } else if (type == "month") {
            setmonthlyhours(parseInt(response / 60));
          } else if (type == "day") {
            settodayshours(parseInt(response / 60));
          }
        })
        .catch((err) => {
          return err;
        });
    } else {
      await getSumofAllNestedItems("slots", employeeid)
        .then(async (response) => {
          setalltimehours(parseInt(response / 60));
        })
        .catch((err) => {
          return err;
        });
    }
  };

  const gethours = async () => {
    await getNestedItemdualcondition(
      "slots",
      employeeid,
      "checkindatetime",
      ">=",
      startdate.getTime(),
      "checkindatetime",
      "<=",
      enddate.getTime(),
      "projectid",
      "==",
      project?.id,
    )
      .then(async (response) => {
        let responsedata = [...response];

        responsedata = responsedata.sort((a, b) => {
          const aTime = a.starttimetimestamp || 0;
          const bTime = b.starttimetimestamp || 0;
          return bTime - aTime; // descending: latest first
        });

        responsedata = responsedata
          .filter(function (data) {
            return (
              (data?.manualhoursaddedby == "employee" &&
                data?.hoursapproved == true) ||
              data?.manualhoursaddedby == undefined
            );
          })
          .map(function (data) {
            return data;
          });
        setemployeecheckindata(responsedata);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  function timeDifference(date1, date2) {
    const startTime = new Date(date1);
    const endTime = new Date(date2);
    const differenceInMs = endTime - startTime;
    const totalMinutes = Math.floor(differenceInMs / (1000 * 60));

    // Convert total minutes to hours and minutes
    const hours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;
    return `${hours} hrs ${minutes} mins`;

    // Helper function to convert time string (hh:mm) to minutes since midnight
    // function timeToMinutes(time) {
    //   const [hours, minutes] = time.split(':').map(Number);
    //   return hours * 60 + minutes;
    // }

    // // Convert times to minutes
    // const startMinutes = timeToMinutes(startTime);
    // const endMinutes = timeToMinutes(endTime);

    // // Calculate the difference in minutes
    // let differenceInMinutes = endMinutes - startMinutes;

    // // If the difference is negative, it means the end time is on the next day
    // if (differenceInMinutes < 0) {
    //   differenceInMinutes += 24 * 60; // Add 24 hours worth of minutes
    // }

    // // Convert difference to hours and minutes
    // const hours = Math.floor(differenceInMinutes / 60);
    // const minutes = differenceInMinutes % 60;

    // return `${hours + ' hrs ' + minutes + ' mins'}`;
  }
  const getgeneralhours = async () => {
    // employees
    // designation
    // console.log(JSON.stringify(project))
    setloading(true);
    setgeneralemployeecheckindata([]);
    let data = [];
    if (project == "") {
      let dataset = [];
      for (const key in employees) {
        dataset.push(employees[key].id);
      }

      await getgeneralNestedItemdualcondition(
        "slots",
        dataset,
        "checkindatetime",
        ">=",
        startdate.getTime(),
        "checkindatetime",
        "<=",
        enddate.getTime(),
      )
        .then(async (response) => {
          let responsedata = [...response];
          for (const index in responsedata) {
            responsedata[index]["name"] = employees
              .filter(function (data) {
                return data.id == responsedata[index].employeeid;
              })
              .map(function (data) {
                return data.firstname + " " + data.lastname;
              });
            responsedata[index]["designation"] = employees
              .filter(function (data) {
                return data.id == responsedata[index].employeeid;
              })
              .map(function (data) {
                return data.projectdesignation;
              });
            responsedata[index]["profilepicture"] = employees
              .filter(function (data) {
                return data.id == responsedata[index].employeeid;
              })
              .map(function (data) {
                return data.profilepicture;
              });
          }
          data = [...data, ...responsedata];
        })
        .catch((err) => {
          console.log(err);
          setloading(false);
        });
    } else {
      let dataset = [];
      for (const key in project.employees) {
        dataset.push(project.employees[key]);
      }

      await getgeneralNestedItemdualcondition(
        "slots",
        dataset,
        "checkindatetime",
        ">=",
        startdate.getTime(),
        "checkindatetime",
        "<=",
        enddate.getTime(),
        "projectid",
        "==",
        project?.id,
      )
        .then(async (response) => {
          let responsedata = [...response];
          for (const index in responsedata) {
            responsedata[index]["name"] = employees
              .filter(function (data) {
                return data.id == responsedata[index].employeeid;
              })
              .map(function (data) {
                return data.firstname + " " + data.lastname;
              });
            responsedata[index]["designation"] = employees
              .filter(function (data) {
                return data.id == responsedata[index].employeeid;
              })
              .map(function (data) {
                return data.projectdesignation;
              });
            responsedata[index]["profilepicture"] = employees
              .filter(function (data) {
                return data.id == responsedata[index].employeeid;
              })
              .map(function (data) {
                return data.profilepicture;
              });
          }
          data = [...data, ...responsedata];
        })
        .catch((err) => {
          console.log(err);
          setloading(false);
        });
    }

    setgeneralemployeecheckindata(data);
    setloading(false);
  };

  const getallemployeejobs = async (id) => {
    await getAllEmployeeTasks("jobs", "assigned", "==", id)
      .then(async (response) => {
        setemployeeprojects(response);
      })
      .catch((err) => {
        alert(err);
      });
  };

  const handleDownloadExcelGeneral = () => {
    let newdata = [];
    generalemployeecheckindata.map((val, id) => {
      const data = clients.find((project) => project.id === val?.projectid);
      const hoursWorked =
        data?.eveningPercentage ||
        data?.normalPercentage ||
        data?.nightPercentage
          ? calculateShiftHours(
              shiftmaker(data),
              val?.checkintime,
              val?.checkouttime,
            )
          : {};
      const normalAmount = val?.priceperhour
        ? calculateSalary(
            hoursWorked?.Normal?.hours,
            hoursWorked?.Normal?.minutes,
            val?.priceperhour,
            shifts[0]?.percentage,
          )
        : 0;
      const eveningAmount = val?.priceperhour
        ? calculateSalary(
            hoursWorked?.Evening?.hours,
            hoursWorked?.Evening?.minutes,
            val?.priceperhour,
            shifts[1]?.percentage,
          )
        : 0;
      const nightAmount = val?.priceperhour
        ? calculateSalary(
            hoursWorked?.Night?.hours,
            hoursWorked?.Night?.minutes,
            val?.priceperhour,
            shifts[2]?.percentage,
          )
        : 0;
      const totalSalary =
        (normalAmount > 0 ? normalAmount : 0) +
        (eveningAmount > 0 ? eveningAmount : 0) +
        (nightAmount > 0 ? nightAmount : 0);
      const mutiplicatorPrice = data?.multiplicatorPercentageStatus
        ? totalSalary * data.multiplicatorPercentage
        : 0;
      const totalHours = val?.minutes
        ? parseInt(val?.minutes / 60) +
          " hrs " +
          parseInt(val?.minutes % 60) +
          " mins"
        : 0 + " mins";
      const fixedPrice =
        data?.fixedprice > 0
          ? calculateFixedAmount(
              val?.minutes ? parseInt(val?.minutes / 60) : 0,
              val?.minutes ? parseInt(val?.minutes % 60) : 0,
              data.fixedprice,
            )
          : 0;
      designation.find((data) => data.selected == true)
        ? designation.find((data) => data.selected == true) == undefined ||
          (designation.find(
            (data) =>
              data.selected == true &&
              val.projectdesignation == data.designation,
          ) != undefined &&
            newdata.push([
              val?.hoursapproved == true
                ? "Approved"
                : val?.hoursapproved == false
                  ? "Rejected"
                  : "Pending",
              val?.approvalstatusupdatedby
                ? val?.approvalstatusupdatedby
                : "NA",
              val.employeeid,
              val.name ? val.name : "NA",
              project.title ? project.title : data ? data.title : "NA",
              val.projectdesignation ? val.projectdesignation : "NA",
              val?.priceperhour,
              val.checkindatetime
                ? moment(val.checkindatetime).format("YYYY-MM-DD hh:mm:ss a")
                : "NA",
              val.lunchstarttime && val.lunchallowed
                ? `${val.sheduleddate + " " + val.lunchstarttime}`
                : "NA",
              val.lunchendtime && val.lunchallowed
                ? `${val.sheduleddate + " " + val.lunchendtime}`
                : "NA",
              val.checkoutdatetime
                ? moment(val.checkoutdatetime).format("YYYY-MM-DD hh:mm:ss a")
                : "NA",
              val.lunchstarttime && val.lunchendtime && val.lunchallowed
                ? timeDifference(
                    val.sheduleddate + " " + val.lunchstarttime,
                    val.sheduleddate + " " + val.lunchendtime,
                  )
                : "NA",
              totalHours,
              hoursWorked?.Normal
                ? hoursWorked.Normal.hours +
                  " hrs " +
                  hoursWorked.Normal.minutes +
                  " mins "
                : "NA",
              hoursWorked?.Evening
                ? hoursWorked.Evening.hours +
                  " hrs " +
                  hoursWorked.Evening.minutes +
                  " mins "
                : "NA",
              hoursWorked?.Night
                ? hoursWorked.Night.hours +
                  " hrs " +
                  hoursWorked.Night.minutes +
                  " mins "
                : "NA",
              normalAmount.toFixed(2),
              eveningAmount.toFixed(2),
              nightAmount.toFixed(2),
              totalSalary ? totalSalary.toFixed(2) : 0,
              mutiplicatorPrice.toFixed(2),
              fixedPrice.toFixed(2),
            ]))
        : newdata.push([
            val?.hoursapproved == true
              ? "Approved"
              : val?.hoursapproved == false
                ? "Rejected"
                : "Pending",
            val?.approvalstatusupdatedby ? val?.approvalstatusupdatedby : "NA",
            val.employeeid,
            val.name ? val.name : "NA",
            project.title ? project.title : data ? data.title : "NA",
            val.projectdesignation ? val.projectdesignation : "NA",
            val?.priceperhour,
            val.checkindatetime
              ? moment(val.checkindatetime).format("YYYY-MM-DD hh:mm:ss a")
              : "NA",
            val.lunchstarttime && val.lunchallowed
              ? `${val.sheduleddate + " " + val.lunchstarttime}`
              : "NA",
            val.lunchendtime && val.lunchallowed
              ? `${val.sheduleddate + " " + val.lunchendtime}`
              : "NA",
            val.checkoutdatetime
              ? moment(val.checkoutdatetime).format("YYYY-MM-DD hh:mm:ss a")
              : "NA",
            val.lunchstarttime && val.lunchendtime && val.lunchallowed
              ? timeDifference(
                  val.sheduleddate + " " + val.lunchstarttime,
                  val.sheduleddate + " " + val.lunchendtime,
                )
              : "NA",
            totalHours,
            hoursWorked?.Normal
              ? hoursWorked.Normal.hours +
                " hrs " +
                hoursWorked.Normal.minutes +
                " mins "
              : "NA",
            hoursWorked?.Evening
              ? hoursWorked.Evening.hours +
                " hrs " +
                hoursWorked.Evening.minutes +
                " mins "
              : "NA",
            hoursWorked?.Night
              ? hoursWorked.Night.hours +
                " hrs " +
                hoursWorked.Night.minutes +
                " mins "
              : "NA",
            normalAmount.toFixed(2),
            eveningAmount.toFixed(2),
            nightAmount.toFixed(2),
            totalSalary ? totalSalary.toFixed(2) : 0,
            mutiplicatorPrice.toFixed(2),
            fixedPrice.toFixed(2),
          ]);
    });
    // console.log(newdata);

    downloadExcel({
      fileName: "General Sheet",
      sheet: "General-Sheet",
      tablePayload: {
        header,
        body: newdata,
      },
    });
  };

  const handleDownloadExcelEmployeeData = async () => {
    // // alert("hello");
    // // ApprovedLeaves
    let leavesdata = [];
    await getAllEmployeeTasks(
      "LeaveApplication",
      "employeeid",
      "==",
      employeedata.id,
    )
      .then(async (response) => {
        if (response?.length > 0) {
          leavesdata = [...response];
        }
      })
      .catch((err) => {
        alert(err);
      });

    leavesdata = leavesdata
      .filter(function (data) {
        return (
          new Date(data.alleaves[0]) >= new Date(startdate) &&
          new Date(data.alleaves[0]) <= new Date(enddate)
        );
      })
      .map(function (data) {
        return data;
      });

    let newdata = [];
    employeecheckindata.reverse().map((val, id) => {
      if (
        val?.checkintime != undefined &&
        val?.checkouttime != undefined &&
        ((val?.manualhoursaddedby == "employee" &&
          val?.hoursapproved == true) ||
          val?.manualhoursaddedby == undefined)
      ) {
        const data = clients.find((project) => project.id === val?.projectid);
        const hoursWorked =
          data?.eveningPercentage ||
          data?.normalPercentage ||
          data?.nightPercentage
            ? calculateShiftHours(
                shiftmaker(data),
                val?.checkintime,
                val?.checkouttime,
              )
            : {};
        const normalAmount = val?.priceperhour
          ? calculateSalary(
              hoursWorked?.Normal?.hours,
              hoursWorked?.Normal?.minutes,
              val?.priceperhour,
              shifts[0]?.percentage,
            )
          : 0;
        const eveningAmount = val?.priceperhour
          ? calculateSalary(
              hoursWorked?.Evening?.hours,
              hoursWorked?.Evening?.minutes,
              val?.priceperhour,
              shifts[1]?.percentage,
            )
          : 0;
        const nightAmount = val?.priceperhour
          ? calculateSalary(
              hoursWorked?.Night?.hours,
              hoursWorked?.Night?.minutes,
              val?.priceperhour,
              shifts[2]?.percentage,
            )
          : 0;
        const totalSalary =
          (normalAmount > 0 ? normalAmount : 0) +
          (eveningAmount > 0 ? eveningAmount : 0) +
          (nightAmount > 0 ? nightAmount : 0);
        const mutiplicatorPrice = data?.multiplicatorPercentageStatus
          ? totalSalary * data.multiplicatorPercentage
          : 0;
        const supervisornotes = val?.supervisornotes
          ? val?.supervisornotes
          : "";
        const totalHours = val?.minutes
          ? parseInt(val?.minutes / 60) +
            " hrs " +
            parseInt(val?.minutes % 60) +
            " mins"
          : 0 + " mins";
        const fixedPrice =
          data?.fixedprice > 0
            ? calculateFixedAmount(
                val?.minutes ? parseInt(val?.minutes / 60) : 0,
                val?.minutes ? parseInt(val?.minutes % 60) : 0,
                data.fixedprice,
              )
            : 0;

        newdata.push({
          "Hours Status":
            val?.hoursapproved == true
              ? "Approved"
              : val?.hoursapproved == false
                ? "Rejected"
                : "Pending",

          "Approved By": val?.approvalstatusupdatedby
            ? val?.approvalstatusupdatedby
            : "NA",
          "Emp ID": employeedata.employeeid,
          Name: employeedata?.firstname
            ? employeedata?.firstname + " " + employeedata?.lastname
            : "NA",
          "Project Title": project.title
            ? project.title
            : data
              ? data.title
              : "NA",
          Designation: val?.projectdesignation ? val?.projectdesignation : "NA",
          "Hourly Salary": val?.priceperhour,
          "Check In": val.checkindatetime
            ? moment(val.checkindatetime).format("YYYY-MM-DD hh:mm:ss a")
            : "NA",
          "Lunch In":
            val.lunchstarttime && val.lunchallowed
              ? `${val.sheduleddate + " " + val.lunchstarttime}`
              : "NA",
          "Lunch Out":
            val.lunchendtime && val.lunchallowed
              ? `${val.sheduleddate + " " + val.lunchendtime}`
              : "NA",
          "Check Out": val.checkoutdatetime
            ? moment(val.checkoutdatetime).format("YYYY-MM-DD hh:mm:ss a")
            : "NA",
          "Total Break Time":
            val.lunchstarttime && val.lunchendtime && val.lunchallowed
              ? timeDifference(
                  val.sheduleddate + " " + val.lunchstarttime,
                  val.sheduleddate + " " + val.lunchendtime,
                )
              : "NA",
          "Total Time Of Day": totalHours,
          "Vehicle Checkin Mileage (KM's)": val?.vehiclecheckinkms
            ? val.vehiclecheckinkms
            : "N/A",
          "Vehicle Checkout Mileage (KM's)": val?.vehiclecheckoutkms
            ? val.vehiclecheckoutkms
            : "N/A",

          "NORMAL HRS": hoursWorked?.Normal
            ? hoursWorked.Normal.hours +
              " hrs " +
              hoursWorked.Normal.minutes +
              " mins "
            : "NA",
          "EVENING HRS": hoursWorked?.Evening
            ? hoursWorked.Evening.hours +
              " hrs " +
              hoursWorked.Evening.minutes +
              " mins "
            : "NA",
          "NIGHT HRS": hoursWorked?.Night
            ? hoursWorked.Night.hours +
              " hrs " +
              hoursWorked.Night.minutes +
              " mins "
            : "NA",
          "HOURLY SALARY NORMAL": normalAmount.toFixed(2),
          "HOURLY SALARY EVENING": eveningAmount.toFixed(2),
          "HOURLY SALARY NIGHT": nightAmount.toFixed(2),
          "TOTAL SALARY": totalSalary ? totalSalary.toFixed(2) : 0,
          "INVOICING AMOUNT WITH A MULTIPLICATOR": mutiplicatorPrice.toFixed(2),
          "Fixed Amount": fixedPrice.toFixed(2),
          "Supervisor Note's": supervisornotes,
        });
      }
    });

    // console.log(newdata);
    const wb = XLSX.utils.book_new();

    const ws1 = XLSX.utils.json_to_sheet(newdata, {
      header: header,
    });
    const holidayheader = [
      "Status",
      "Eployee ID",
      "Eployee Name",
      "From",
      "To",
      "Type",
      "Reason",
    ];

    let newholidaydata = [];
    leavesdata.map((val, id) => {
      newholidaydata.push({
        Status: val.status,
        "Eployee ID": employeedata.employeeid,
        "Eployee Name": employeedata?.firstname
          ? employeedata?.firstname + " " + employeedata?.lastname
          : "NA",
        From: val.alleaves[0],
        To: val.alleaves[val.alleaves.length - 1],
        Type: val.type,
        Reason: val.reason,
      });
    });
    const ws2 = XLSX.utils.json_to_sheet(newholidaydata, {
      header: holidayheader,
    });

    XLSX.utils.book_append_sheet(wb, ws1, "Hours Worked");
    XLSX.utils.book_append_sheet(wb, ws2, "Holidays");

    const fileName = `${
      employeedata?.firstname
        ? employeedata?.firstname + " " + employeedata?.lastname
        : "Employee Sheet"
    }.xlsx`;

    const wbout = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    saveAs(new Blob([wbout], { type: "application/octet-stream" }), fileName);
    return;
    downloadExcel({
      fileName: `${
        employeedata?.firstname
          ? employeedata?.firstname + " " + employeedata?.lastname
          : "Employee Sheet"
      }`,
      sheet: "Employee-Sheet",
      tablePayload: {
        header,
        body: newdata,
      },
    });
  };
  // Define the shifts with their start and end times
  const shifts = [];
  function shiftmaker(data) {
    console.log(data);
    if (data?.normalstarttime && data?.normalstarttime) {
      shifts.push({
        name: "Normal",
        start: data?.normalstarttime,
        end: data?.normalendtime,
        percentage: data?.normalPercentage,
      });
    }
    if (data?.eveningstarttime && data?.eveningstarttime) {
      shifts.push({
        name: "Evening",
        start: data?.eveningstarttime,
        end: data?.eveningendtime,
        percentage: data?.eveningPercentage,
      });
    }
    if (data?.nightstarttime && data?.nightstarttime) {
      shifts.push({
        name: "Night",
        start: data?.nightstarttime,
        end: data?.nightendtime,
        percentage: data?.nightPercentage,
      });
    }
    return shifts;
  }

  // Convert time string to Date object for a given date
  // Convert time string to Date object for a given date
  function parseTime(timeStr, baseDate) {
    const [hours, minutes] = timeStr.split(":").map(Number);
    return new Date(
      baseDate.getFullYear(),
      baseDate.getMonth(),
      baseDate.getDate(),
      hours,
      minutes,
    );
  }

  // Calculate hours worked within a time range in hours and minutes
  function calculateOverlap(start1, end1, start2, end2) {
    const start = Math.max(start1.getTime(), start2.getTime());
    const end = Math.min(end1.getTime(), end2.getTime());

    if (start >= end) return { hours: 0, minutes: 0 }; // No overlap

    const overlapMillis = end - start;
    const hours = Math.floor(overlapMillis / (1000 * 60 * 60));
    const minutes = Math.floor(
      (overlapMillis % (1000 * 60 * 60)) / (1000 * 60),
    );
    return { hours, minutes };
  }

  // Calculate hours worked in each shift and return in hours and minutes
  function calculateShiftHours(shifts, workStartTime, workEndTime) {
    let shiftHours = {};

    const baseDate = new Date(); // Use current date as base

    const workStart = parseTime(workStartTime, baseDate);
    const workEnd = parseTime(workEndTime, baseDate);

    shifts.forEach((shift) => {
      const shiftStart = parseTime(shift.start, baseDate);
      const shiftEnd = parseTime(shift.end, baseDate);

      if (shift.start > shift.end) {
        // Shift spans overnight
        const shiftEndMidnight = new Date(baseDate);
        shiftEndMidnight.setDate(shiftEndMidnight.getDate() + 1);
        shiftEndMidnight.setHours(shiftEnd.getHours());
        shiftEndMidnight.setMinutes(shiftEnd.getMinutes());

        const overlap1 = calculateOverlap(
          workStart,
          workEnd,
          shiftStart,
          shiftEndMidnight,
        );
        const overlap2 = calculateOverlap(
          workStart,
          workEnd,
          new Date(baseDate),
          shiftEnd,
        );

        shiftHours[shift.name] = {
          hours: overlap1.hours + overlap2.hours,
          minutes: overlap1.minutes + overlap2.minutes,
        };
      } else {
        // Shift within a single day
        const overlap = calculateOverlap(
          workStart,
          workEnd,
          shiftStart,
          shiftEnd,
        );
        shiftHours[shift.name] = overlap;
      }
    });

    // Convert minutes to hours if greater than 60
    for (const shift in shiftHours) {
      const shiftTime = shiftHours[shift];
      if (shiftTime.minutes >= 60) {
        shiftTime.hours += Math.floor(shiftTime.minutes / 60);
        shiftTime.minutes = shiftTime.minutes % 60;
      }
    }

    return shiftHours;
  }
  function calculateSalary(
    hoursWorked,
    minutesWorked,
    perHourRate,
    percentage,
  ) {
    // console.log(hoursWorked, minutesWorked, perHourRate, percentage);
    // Convert total hours and minutes into total hours
    const totalHours = hoursWorked + minutesWorked / 60;

    // Apply percentage adjustment
    const adjustmentAmount = perHourRate * (percentage / 100);
    // Calculate base salary

    // const baseSalary = totalHours * perHourRate;
    const finalSalary = totalHours * adjustmentAmount;
    // console.log(totalHours, adjustmentAmount);
    return finalSalary ? finalSalary : 0;
  }
  function calculateFixedAmount(hours, minutes, perHourRate) {
    // Convert minutes to hours
    const minutesInHours = minutes / 60;

    // Total hours including minutes
    const totalHours = hours + minutesInHours;
    // Calculate total amount
    const totalAmount = totalHours * perHourRate;

    return totalAmount ? totalAmount : 0;
  }

  function SupervisorPermissions() {
    return (employeedata.usertype == "Supervisor" &&
      user.usertype == "Admin") ||
      (employeedata.usertype == "Supervisor" &&
        user.usertype == "SuperAdmin") ? (
      <div className="w-full flex flex-row flex-wrap justify-evenly items-center  mt-[40px]">
        <div className="flex flex-col items-center mb-[20px] min-w-[100px]">
          <p className="text-white PoppinsRegular  text-sm pb-[5px]">
            Delete Access
          </p>
          <Switch
            height={25}
            width={50}
            checkedIcon={false}
            uncheckedIcon={false}
            onChange={() => {
              updateemployeedata(
                "deleteaccess",
                employeedata?.deleteaccess ? false : true,
                employeedata.id,
              );
            }}
            checked={employeedata?.deleteaccess}
            onColor={"#1F2E5E"}
          />
        </div>
        <div className="flex flex-col items-center mb-[20px] min-w-[100px]">
          <p className="text-white PoppinsRegular  text-sm pb-[5px]">
            Bulk Edit Access
          </p>
          <Switch
            height={25}
            width={50}
            checkedIcon={false}
            uncheckedIcon={false}
            onChange={() => {
              updateemployeedata(
                "bulkeditaccess",
                employeedata?.bulkeditaccess ? false : true,
                employeedata.id,
              );
            }}
            checked={employeedata?.bulkeditaccess}
            onColor={"#1F2E5E"}
          />
        </div>
        <div className="flex flex-col items-center mb-[20px] min-w-[100px]">
          <p className="text-white PoppinsRegular  text-sm pb-[5px]">
            Edit Access
          </p>
          <Switch
            height={25}
            width={50}
            checkedIcon={false}
            uncheckedIcon={false}
            onChange={() => {
              updateemployeedata(
                "editaccess",
                employeedata?.editaccess ? false : true,
                employeedata.id,
              );
            }}
            checked={employeedata?.editaccess}
            onColor={"#1F2E5E"}
          />
        </div>

        <div className="flex flex-col items-center mb-[20px] min-w-[100px]">
          <p className="text-white PoppinsRegular  text-sm pb-[5px]">
            Report Access
          </p>
          <Switch
            height={25}
            width={50}
            checkedIcon={false}
            uncheckedIcon={false}
            onChange={() => {
              updateemployeedata(
                "reportaccess",
                employeedata?.reportaccess ? false : true,
                employeedata.id,
              );
            }}
            checked={employeedata?.reportaccess}
            onColor={"#1F2E5E"}
          />
        </div>
        {employeedata?.clientrole != true && (
          <div className="flex flex-col items-center mb-[20px] min-w-[100px]">
            <p className="text-white PoppinsRegular  text-sm pb-[5px]">
              Worker Role
            </p>
            <Switch
              height={25}
              width={50}
              checkedIcon={false}
              uncheckedIcon={false}
              onChange={() => {
                updateemployeedata(
                  "employeerole",
                  employeedata?.employeerole ? false : true,
                  employeedata.id,
                );
              }}
              checked={employeedata?.employeerole}
              onColor={"#1F2E5E"}
            />
          </div>
        )}
        {employeedata?.clientrole != true && (
          <div className="flex flex-col items-center mb-[20px] min-w-[100px]">
            <p className="text-white PoppinsRegular  text-sm pb-[5px]">
              Vehicle Creation
            </p>
            <Switch
              height={25}
              width={50}
              checkedIcon={false}
              uncheckedIcon={false}
              onChange={() => {
                updateemployeedata(
                  "vehiclecreationrole",
                  employeedata?.vehiclecreationrole ? false : true,
                  employeedata.id,
                );
              }}
              checked={employeedata?.vehiclecreationrole}
              onColor={"#1F2E5E"}
            />
          </div>
        )}
        <div className="flex flex-col items-center mb-[20px] min-w-[100px]">
          <p className="text-white PoppinsRegular  text-sm pb-[5px]">
            Schedule Creation
          </p>
          <Switch
            height={25}
            width={50}
            checkedIcon={false}
            uncheckedIcon={false}
            onChange={() => {
              updateemployeedata(
                "scheduleaccess",
                employeedata?.scheduleaccess ? false : true,
                employeedata.id,
              );
            }}
            checked={employeedata?.scheduleaccess}
            onColor={"#1F2E5E"}
          />
        </div>
        <div className="flex flex-col items-center mb-[20px] min-w-[100px]">
          <p className="text-white PoppinsRegular  text-sm pb-[5px]">
            Client Role
          </p>
          <Switch
            height={25}
            width={50}
            checkedIcon={false}
            uncheckedIcon={false}
            onChange={() => {
              updateemployeedata(
                "clientrole",
                employeedata?.clientrole ? false : true,
                employeedata.id,
              );
            }}
            checked={employeedata?.clientrole}
            onColor={"#1F2E5E"}
          />
        </div>
      </div>
    ) : null;
  }

  function DiabledDate() {
    return (
      employeedata?.disabled && (
        <p className=" text-red-500 PoppinsRegular  text-sm">{`Disabled On: ${moment(
          employeedata.diableddate,
        ).format("DD-MM-YYYY")}`}</p>
      )
    );
  }

  // Example usage
  // console.log(clients, 'newd');
  // console.log(employeecheckindata, 'ppp');
  // console.log(designation);
  return (
    <div className="w-[100%] mt-[30px] md:mt-[0px] px-[10px]  flex flex-col justify-center relative bg-themeColor">
      <div className=" md:mx-[30px] ">
        <div className="w-full flex flex-row justify-between  md:pt-[20px]  pb-[10px] mt-[80px]  ">
          <div className="flex flex-row items-center">
            {/* <p
            onClick={() => { setfiltertype("General") }}
            className={`PoppinsRegular text-[14px]   hover:cursor-pointer hover:underline  ${filtertype == "General" ? "text-themegreen  text-[15px]" : "text-white"}`} >General</p>
          <p className='mx-[10px]'>|</p> */}
            <p
              onClick={() => {
                setfiltertype("Active");
              }}
              className={`PoppinsRegular text-[14px]   hover:cursor-pointer hover:underline  ${
                filtertype == "Active"
                  ? "text-themegreen  text-[15px]"
                  : "text-white"
              } `}
            >
              Active
            </p>
            <p className="mx-[10px]">|</p>
            <p
              onClick={() => {
                setfiltertype("InActive");
              }}
              className={`PoppinsRegular text-[14px]   hover:cursor-pointer hover:underline  ${
                filtertype == "InActive"
                  ? "text-themegreen  text-[15px]"
                  : "text-white"
              }`}
            >
              InActive
            </p>
          </div>
          {filtertype == "Active" && (
            <div>
              <FaPlus
                onClick={() => {
                  navigate("/UpdateSlot");
                }}
                color="#00C763"
                size={"20"}
                className={`mt-1.5 hover:cursor-pointer`}
              />
            </div>
          )}
        </div>
      </div>

      <Confirmationpopup
        visible={employeedeletionconfirmation}
        picture={employeedata?.profilepicture}
        text={`Are you sure you want to ${
          employeedata?.disabled ? "enable" : "disable"
        } ${employeedata?.firstname + " " + employeedata?.lastname}?`}
        accept={() => {
          setemployeedeletionconfirmation(false);
          if (employeedata?.disabled) {
            disableemployeetoggle(employeedata, false);
          } else {
            disableemployeetoggle(employeedata, true);
          }
        }}
        cancel={() => {
          setemployeedeletionconfirmation(false);
        }}
      />

      <UploadPaymentPopUp
        visible={uploadpaymenttoggle}
        picture={employeedata?.profilepicture}
        id={employeeid}
        accept={() => {}}
        cancel={() => {
          setuploadpaymenttoggle(false);
        }}
      />

      {
        filtertype == "Active" || filtertype == "InActive" ? (
          <div className="mb-[40px]">
            <div className="hidden lg:flex flex-row rounded-xl  mx-[30px]    bg-themeColor  drop-shadow-lg bg-cardOverlay   ">
              <div className="w-[25%] bg-themelightblack  bg-cardOverlay  drop-shadow-lg rounded-s-xl overflow-y-scroll min-h-screen">
                <div className="h-[30px] relative flex items-center w-full mt-[20px] mb-[10px] px-[20px] ">
                  <input
                    type="text"
                    placeholder="Search"
                    value={searchtext}
                    onChange={handlesearchChange}
                    className="input pl-10 text-white text-sm  rounded-full PoppinsRegular w-[100%] py-2 border border-white/20  items-center flex bg-themelightblack "
                  />
                  <div className="absolute left-[30px] ">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke-width="1.5"
                      className="w-5 h-5 stroke-white"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        d="m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607Z"
                      />
                    </svg>
                  </div>
                </div>
                {employees.map((item, index) => {
                  let employeefullname = item?.firstname + " " + item?.lastname;
                  return (filtertype == "Active" &&
                    item.disabled != true &&
                    item.delete != true &&
                    employeefullname
                      .toLowerCase()
                      .includes(searchtext.toLowerCase())) ||
                    (filtertype == "InActive" &&
                      item.disabled == true &&
                      item.delete != true &&
                      employeefullname
                        .toLowerCase()
                        .includes(searchtext.toLowerCase())) ? (
                    <div
                      key={index.toString()}
                      onClick={() => {
                        dispatch({
                          type: actionType.EMPLOYEEID,
                          payload: item.id,
                        });

                        dispatch({
                          type: actionType.EMPLOYEEDATA,
                          payload: item,
                        });
                      }}
                      className="w-[100%] hover:bg-themeblue cursor-pointer py-4  flex flex-row items-center px-5 text-white  "
                    >
                      <img
                        loading="lazy"
                        src={item.profilepicture}
                        className="w-[35px] h-[35px] object-cover rounded-full"
                      />
                      <div className="flex flex-col">
                        <p className="PoppinsRegular font-bold text-base pl-3 ">
                          {item.firstname + " " + item.lastname}
                        </p>
                      </div>
                    </div>
                  ) : null;
                })}
              </div>
              <div className="w-[75%]">
                <div className="w-[95%] mx-auto mt-10 ">
                  <div className="grid grid-cols-2 gap-4 md:grid-cols-4 lg:gap-8">
                    <div className="flex flex-col items-center justify-center rounded-lg bg-themelightblack p-4 lg:p-8  bg-cardOverlay  drop-shadow-lg">
                      <p className="text-xl text-white PoppinsRegular  sm:text-2xl md:text-lg text-center">
                        Today's Work
                      </p>
                      <div className="text-sm  sm:text-base text-white PoppinsRegular">
                        {todayshours + " hrs"}
                      </div>
                    </div>

                    <div className="flex flex-col items-center justify-center rounded-lg  p-4 md:p-8 bg-themelightblack bg-cardOverlay  drop-shadow-lg">
                      <div className="text-xl text-white PoppinsRegular  sm:text-2xl md:text-lg text-center">
                        Week's Work
                      </div>
                      <div className="text-sm  text-white PoppinsRegular sm:text-base">
                        {weeklyhours + " hrs"}
                      </div>
                    </div>

                    <div className="flex flex-col items-center justify-center rounded-lg bg-themelightblack p-4 md:p-8  bg-cardOverlay  drop-shadow-lg">
                      <div className="text-xl text-white PoppinsRegular  sm:text-2xl md:text-lg text-center">
                        Month's Work
                      </div>
                      <div className="text-sm  text-white PoppinsRegular sm:text-base">
                        {monthlyhours + " hrs"}
                      </div>
                    </div>

                    <div className="flex flex-col items-center justify-center rounded-lg  bg-themelightblack p-4 md:p-8  bg-cardOverlay  drop-shadow-lg">
                      <div className="text-xl text-white PoppinsRegular  sm:text-2xl md:text-lg text-center">
                        Total Work
                      </div>
                      <div className="text-sm  text-white PoppinsRegular sm:text-base">
                        {alltimehours + " hrs"}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="flex flex-col w-full items-center justify-center my-14">
                  <div className="flex flex-row justify-end w-full px-[25px] mb-[20px] ">
                    {(user.usertype == "Supervisor" &&
                      user?.editaccess == true) ||
                    user.usertype == "Admin" ||
                    user.usertype == "SuperAdmin" ? (
                      <div className="px-[20px] py-[5px] bg-themeblue rounded-md  hover:cursor-pointer hover:bg-themeblue/80 mr-[10px]">
                        <p
                          onClick={() => {
                            setuploadpaymenttoggle(true);
                          }}
                          className="text-sm  text-white PoppinsRegular "
                        >
                          Upload Payment Slip
                        </p>
                      </div>
                    ) : null}
                    {(user.usertype == "Supervisor" &&
                      user?.editaccess == true) ||
                    user.usertype == "Admin" ||
                    user.usertype == "SuperAdmin" ? (
                      <div className="px-[20px] py-[5px] bg-themeblue rounded-md  hover:cursor-pointer hover:bg-themeblue/80">
                        <p
                          onClick={() => {
                            navigate("/dashboard", {
                              state: {
                                employeedata: employeedata,
                              },
                            });
                          }}
                          className="text-sm  text-white PoppinsRegular "
                        >
                          Edit
                        </p>
                      </div>
                    ) : null}
                    {employeedata?.disabled && (
                      <div className="px-[20px] py-[5px] bg-themeColor rounded-md  hover:cursor-pointer hover:bg-themeblue/80 ml-[10px]">
                        <p
                          onClick={() => {
                            deleteeemployee(employeedata);
                          }}
                          className="text-sm  text-white PoppinsRegular "
                        >
                          Delete
                        </p>
                      </div>
                    )}
                    {employeecheckindata?.length > 0 && !user?.clientrole && (
                      <div className="px-[20px] py-[5px] bg-themeblue rounded-md ml-[10px] hover:cursor-pointer hover:bg-themeblue/80">
                        <p
                          onClick={() => handleDownloadExcelEmployeeData()}
                          className="text-sm  text-white PoppinsRegular "
                        >
                          Export
                        </p>
                      </div>
                    )}
                  </div>
                  <div className="flex flex-col items-center w-full">
                    <img
                      loading="lazy"
                      src={employeedata?.profilepicture}
                      className="w-[130px] h-[130px] rounded-full object-cover  bg-cardOverlay  drop-shadow-lg"
                    />
                    {employeedata ? (
                      <div className="flex flex-col text-center pt-2 w-full">
                        <p className="text-white PoppinsRegular font-bold text-xl">
                          {employeedata?.firstname +
                            " " +
                            employeedata?.lastname}
                        </p>
                        <p className="text-white/60 PoppinsRegular  text-sm">
                          {employeedata?.clientrole
                            ? "Client"
                            : employeedata?.designation}
                        </p>
                        <p className="text-white/60 PoppinsRegular  text-sm">
                          {String(employeedata.employeeid).padStart(4, "0")}
                        </p>

                        {(user.usertype == "Supervisor" &&
                          user?.editaccess == true) ||
                        user.usertype == "Admin" ||
                        user.usertype == "SuperAdmin" ? (
                          <p
                            className={`${
                              employeedata?.leaves > 0
                                ? "text-themegreen"
                                : "text-red-500"
                            } PoppinsRegular  text-sm`}
                          >
                            {`Available Leaves: ${employeedata?.leaves}`}
                          </p>
                        ) : null}
                        {DiabledDate()}
                        {SupervisorPermissions()}
                      </div>
                    ) : (
                      <div className="flex flex-col text-center pt-2">
                        <p className="text-white PoppinsRegular font-bold text-xl">
                          {"No User Found"}
                        </p>
                      </div>
                    )}
                  </div>
                </div>

                {(user.usertype == "Supervisor" && user?.reportaccess) ||
                user.usertype == "Admin" ||
                user.usertype == "SuperAdmin" ? (
                  <>
                    <div className="w-full px-[10px] flex flex-row justify-between items-center">
                      <div className="w-[32%] relative">
                        <div className="flex flex-row items-end  pb-[10px] ">
                          <p className="PoppinsRegular   text-white/80 text-sm">
                            Select Project
                          </p>
                          {project.title && (
                            <p
                              onClick={() => {
                                setprojectselectionpopup2(false);
                                dispatch({
                                  type: actionType.SELECTPROJECT,
                                  payload: "",
                                });
                              }}
                              className="ml-[5px] text-[13px] text-red-600 cursor-pointer hover:underline"
                            >
                              Clear
                            </p>
                          )}
                        </div>
                        <div
                          onClick={() => {
                            setprojectselectionpopup2(!projectselectionpopup2);
                          }}
                          className="px-4 text-white text-sm  PoppinsRegular  w-full py-[10px] rounded-xl items-center flex  bg-themelightblack  bg-cardOverlay  drop-shadow-lg cursor-pointer"
                        >
                          {project == "" ? "Select Project" : project.title}
                        </div>

                        <ProjectPopUp
                          style={{ top: "80px" }}
                          visible={projectselectionpopup2}
                          data={clients}
                          activateoutsidecontainerclick={() => {
                            setprojectselectionpopup2(false);
                          }}
                          onClickcorrect={(item) => {
                            dispatch({
                              type: actionType.SELECTPROJECT,
                              payload: item,
                            });
                            let data = { ...item };
                            if (data?.designation?.length > 0) {
                              for (const key in data.designation) {
                                data.designation[key]["selected"] = false;
                              }
                            }
                            setdesignation(data.designation);

                            setprojectselectionpopup2(!projectselectionpopup2);
                          }}
                        />
                      </div>

                      <div className="w-[32%]">
                        <p className="PoppinsRegular  text-white/80 text-sm pb-[10px]">
                          From
                        </p>
                        <DatePicker
                          className="input border-none text-white PoppinsRegular   bg-themelightblack  bg-cardOverlay  drop-shadow-lg  cursor-pointer   rounded-xl w-full"
                          selected={startdate}
                          onChange={(date) => {
                            dispatch({
                              type: actionType.STARTDATE,
                              payload: new Date(date.setHours(0, 0, 0, 0)),
                            });
                          }}
                        />
                      </div>
                      {/* <text className='mx-[50px]'>to</text> */}
                      <div className="w-[32%]">
                        <p className="PoppinsRegular  text-white text-sm pb-[10px]">
                          To
                        </p>
                        <DatePicker
                          className="input border-none PoppinsRegular   text-white  bg-themelightblack  bg-cardOverlay  drop-shadow-lg  cursor-pointer  rounded-xl w-full"
                          selected={enddate}
                          onChange={(date) => {
                            dispatch({
                              type: actionType.ENDDATE,
                              payload: new Date(date.setHours(23, 59, 59, 59)),
                            });
                          }}
                        />
                      </div>
                    </div>

                    <div className="flex flex-col w-full px-[10px] mt-[10px]">
                      {/* <div

              //   className='w-[100%] border border-black flex flex-row items-center justify-between px-[5px]'>
              //   <div className='flex flex-col items-center'>
              //     <text className='text-white text-[15px]'>{"Date"}</text>
              //     <text className='text-white text-[15px]'>{item.checkindate}</text>
              //   </div>
              //   <div className='flex flex-col items-center'>
              //     <text className='text-white text-[15px]'>{"Checkin Time"}</text>
              //     <text className='text-white text-[15px]'>{item.checkintime}</text>
              //   </div>

              //   <div className='flex flex-col items-center'>
              //     <text className='text-white text-[15px]'>{"Checkout Time"}</text>
              //     <text className='text-white text-[15px]'>{item.checkouttime ? item.checkouttime : "Not Available"}</text>
              //   </div>
              //   <div className='flex flex-col items-center'>
              //     <text className='text-white text-[15px]'>{"Hours Worked"}</text>
              //     <text className='text-white text-[15px]'>{item?.minutes ? parseInt(item?.minutes / 60) : 0}</text>
              //   </div>
              //   <div className='flex flex-col items-center'>
              //     <text className='text-white text-[15px]'>{"Checkin Location"}</text>
              //     <div
              //       onClick={() => {
              //         getlocationaddress(item?.checkinlatitude, item?.checkinlongitude)
              //       }}
              //     >
              //       <text className='text-white text-[15px]'>View</text>
              //     </div>
              //   </div>
              //   <div className='flex flex-col items-center'>
              //     <text className='text-white text-[15px]'>{"Checkout Location"}</text>
              //     <div
              //       onClick={() => {
              //         getlocationaddress(item?.checkoutlatitude, item?.checkoutlongitude)
              //       }}
              //     >
              //       <text className='text-white text-[15px]'>View</text>
              //     </div>
              //   </div>

              // </div> */}

                      <div className="overflow-x-auto rounded-lg bg-themelightblack  bg-cardOverlay  drop-shadow-lg mb-[10px]  ">
                        <table className="min-w-full divide-y divide-white/20 text-sm ">
                          <thead className="ltr:text-left rtl:text-right">
                            <tr>
                              <th className="whitespace-nowrap py-2  PoppinsRegular text-white"></th>
                              <th className="whitespace-nowrap py-2  PoppinsRegular text-white">
                                Date
                              </th>
                              <th className="whitespace-nowrap py-2  PoppinsRegular text-white">
                                Checkin Time
                              </th>
                              <th className="whitespace-nowrap py-2  PoppinsRegular text-white">
                                Checkout Time
                              </th>
                              <th className="whitespace-nowrap py-2  PoppinsRegular text-white">
                                Hours Worked
                              </th>
                              <th className="whitespace-nowrap py-2  PoppinsRegular text-white">
                                Checkin Location
                              </th>
                              <th className="whitespace-nowrap py-2  PoppinsRegular text-white">
                                Checkout Location
                              </th>
                            </tr>
                          </thead>
                          <tbody className="text-center w-full">
                            {employeecheckindata.map((item, index) => (
                              <tr
                                key={index.toString()}
                                className="hover:bg-[#0989B826]/10 cursor-pointer"
                              >
                                {/* Edit Document */}
                                <td className="w-[50px] whitespace-nowrap px-4 py-2 PoppinsRegular">
                                  <MdEditDocument
                                    onClick={() => {
                                      navigate("/UpdateSlot", {
                                        state: {
                                          edit: true,
                                          editdoc: item,
                                          projectid: item.projectid,
                                          employeedata: employeedata,
                                          projectdesignation:
                                            item.projectdesignation,
                                        },
                                      });
                                    }}
                                    className="text-lighttextGray hover:text-themegreen w-[17px] h-[17px] hover:cursor-pointer mx-auto"
                                  />
                                </td>

                                {/* Date */}
                                <td className="w-[110px] whitespace-nowrap px-4 py-2 PoppinsRegular text-white">
                                  {moment(item.checkindate).format(
                                    "DD-MM-YYYY",
                                  )}
                                </td>

                                {/* Checkin Time */}
                                <td className="w-[110px] whitespace-nowrap px-4 py-2 PoppinsRegular">
                                  {item.checkintime ? (
                                    <span className="text-white">
                                      {item.checkintime}
                                    </span>
                                  ) : (
                                    <span className="text-white/40">
                                      Not Available
                                    </span>
                                  )}
                                </td>

                                {/* Checkout Time */}
                                <td className="w-[110px] whitespace-nowrap px-4 py-2 PoppinsRegular">
                                  {item.checkouttime ? (
                                    <span className="text-white">
                                      {item.checkouttime}
                                    </span>
                                  ) : (
                                    <span className="text-white/40">
                                      Not Available
                                    </span>
                                  )}
                                </td>

                                {/* Minutes / Hours Worked */}
                                <td className="w-[120px] whitespace-nowrap px-4 py-2 PoppinsRegular">
                                  {item?.minutes ? (
                                    <span className="text-themegreen">
                                      {parseInt(item?.minutes / 60) +
                                        " hrs " +
                                        parseInt(item?.minutes % 60) +
                                        " mins"}
                                    </span>
                                  ) : (
                                    <span className="text-white/40">NA</span>
                                  )}
                                </td>

                                {/* Checkin Location */}
                                <td
                                  className="w-[130px] whitespace-nowrap px-4 py-2 PoppinsRegular"
                                  onClick={() => {
                                    if (item?.checkinlatitude) {
                                      getlocationaddress(
                                        item?.checkinlatitude,
                                        item?.checkinlongitude,
                                      );
                                    }
                                  }}
                                >
                                  {item?.checkinlatitude ? (
                                    <span className="text-white cursor-pointer hover:underline">
                                      View
                                    </span>
                                  ) : (
                                    <span className="text-white/40">
                                      Not Available
                                    </span>
                                  )}
                                </td>

                                {/* Checkout Location */}
                                <td
                                  className="w-[130px] whitespace-nowrap px-4 py-2 PoppinsRegular"
                                  onClick={() => {
                                    if (item?.checkoutlatitude) {
                                      getlocationaddress(
                                        item?.checkoutlatitude,
                                        item?.checkoutlongitude,
                                      );
                                    }
                                  }}
                                >
                                  {item?.checkoutlatitude ? (
                                    <span className="text-white cursor-pointer hover:underline">
                                      View
                                    </span>
                                  ) : (
                                    <span className="text-white/40">
                                      Not Available
                                    </span>
                                  )}
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </>
                ) : null}
                {(user.usertype == "Supervisor" && user?.editaccess == true) ||
                user.usertype == "Admin" ||
                user.usertype == "SuperAdmin" ? (
                  <>
                    {employeedata && (
                      <div className=" w-full px-[10px] mt-[10px] mb-[10px]">
                        {disableloader ? (
                          <div className=" py-4  mt-6  w-full flex justify-center  ">
                            <RotatingLines
                              visible={true}
                              height="25"
                              width="25"
                              color="grey"
                              strokeColor="#FF0000"
                              strokeWidth="5"
                              animationDuration="0.75"
                              ariaLabel="rotating-lines-loading"
                              wrapperStyle={{}}
                              wrapperClass=""
                            />
                          </div>
                        ) : (
                          <button
                            onClick={() => {
                              setemployeedeletionconfirmation(true);
                            }}
                            type="submit"
                            className={`text-center py-4 rounded-lg  ${
                              employeedata?.disabled
                                ? "bg-themegreen hover:bg-themegreen/80"
                                : "bg-red-600 hover:bg-red-600/80"
                            } w-full  mx-auto text-white text-sm  PoppinsRegular `}
                          >
                            {employeedata?.disabled
                              ? "Enable Employee"
                              : "Disable Employee"}
                          </button>
                        )}
                      </div>
                    )}
                  </>
                ) : null}
              </div>
            </div>

            {/* mobile view */}
            <div className="lg:hidden  rounded-xl mb-20   bg-themeColor   bg-cardOverlay  drop-shadow-lg pb-[20px]">
              {!employeeid ? (
                <div>
                  <div className="h-[100%] relative flex items-center w-full mt-[20px] mb-[10px] px-[20px]">
                    <input
                      type="text"
                      placeholder="Search"
                      value={searchtext}
                      onChange={handlesearchChange}
                      className="input pl-10  text-sm  rounded-full PoppinsRegular w-[100%] py-2  border border-white/20 items-center flex bg-themelightblack text-white"
                    />
                    <div className="absolute left-[30px] ">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke-width="1.5"
                        className="w-5 h-5 stroke-white"
                      >
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          d="m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607Z"
                        />
                      </svg>
                    </div>
                  </div>
                  {employees.map((item, index) => {
                    let employeefullname =
                      item?.firstname + " " + item?.lastname;
                    return (filtertype == "Active" &&
                      item.disabled != true &&
                      item.delete != true &&
                      employeefullname
                        .toLowerCase()
                        .includes(searchtext.toLowerCase())) ||
                      (filtertype == "InActive" &&
                        item.disabled == true &&
                        item.delete != true &&
                        employeefullname
                          .toLowerCase()
                          .includes(searchtext.toLowerCase())) ? (
                      <div
                        key={index.toString()}
                        onClick={() => {
                          dispatch({
                            type: actionType.EMPLOYEEID,
                            payload: item.id,
                          });

                          dispatch({
                            type: actionType.EMPLOYEEDATA,
                            payload: item,
                          });
                        }}
                        className="w-[100%] text-white  hover:bg-themeblue cursor-pointer py-4  flex flex-row items-center px-5"
                      >
                        <img
                          loading="lazy"
                          src={item.profilepicture}
                          className="w-[35px] h-[35px] object-cover rounded-full"
                        />
                        <div className="flex flex-col">
                          <p className=" PoppinsRegular font-bold text-base pl-3">
                            {item.firstname + " " + item.lastname}
                          </p>
                        </div>
                      </div>
                    ) : null;
                  })}
                </div>
              ) : (
                <div className="mt-[30px] lg:mt-10">
                  <div
                    className=" cursor-pointer w-[95%] mx-auto  flex "
                    onClick={() => {
                      dispatch({
                        type: actionType.EMPLOYEEID,
                        payload: 0,
                      });

                      dispatch({
                        type: actionType.EMPLOYEEDATA,
                        payload: "",
                      });
                    }}
                  >
                    <HiArrowLeft className={` text-white text-[25px]`} />
                  </div>
                  <div className="w-[95%] mx-auto mt-5 lg:mt-10">
                    <div className="grid grid-cols-2 gap-4 md:grid-cols-4 lg:gap-8">
                      <div className="flex flex-col items-center justify-center rounded-lg  bg-themelightblack p-4 lg:p-8  bg-cardOverlay  drop-shadow-lg">
                        <p className="text-base text-white PoppinsRegular  md:text-lg">
                          Today's Work
                        </p>
                        <div className="text-sm  text-white/50 PoppinsRegular">
                          {todayshours + " hrs"}
                        </div>
                      </div>

                      <div className="flex flex-col items-center justify-center rounded-lg bg-themelightblack p-4 md:p-8  bg-cardOverlay  drop-shadow-lg">
                        <div className="text-base text-white PoppinsRegular  md:text-lg">
                          Weeks's Work
                        </div>
                        <div className="text-sm  text-white/50 PoppinsRegular">
                          {weeklyhours + " hrs"}
                        </div>
                      </div>

                      <div className="flex flex-col items-center justify-center rounded-lg bg-themelightblack p-4 md:p-8  bg-cardOverlay  drop-shadow-lg">
                        <div className="text-base text-white PoppinsRegular  md:text-lg">
                          Months's Work
                        </div>
                        <div className="text-sm  text-white/50 PoppinsRegular">
                          {monthlyhours + " hrs"}
                        </div>
                      </div>

                      <div className="flex flex-col items-center justify-center rounded-lg bg-themelightblack p-4 md:p-8  bg-cardOverlay  drop-shadow-lg">
                        <div className="text-base text-white PoppinsRegular  md:text-lg">
                          Total Work Time
                        </div>
                        <div className="text-sm  text-white/50 PoppinsRegular">
                          {alltimehours + " hrs"}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="flex flex-col w-full items-center justify-center my-12">
                    <div className="flex flex-row justify-end w-full px-[25px] mb-[40px] ">
                      {(user.usertype == "Supervisor" &&
                        user?.editaccess == true) ||
                      user.usertype == "Admin" ||
                      user.usertype == "SuperAdmin" ? (
                        <div className="px-[20px] py-[5px] bg-themeblue rounded-md  hover:cursor-pointer hover:bg-themeblue/80 mr-[10px]">
                          <p
                            onClick={() => {
                              setuploadpaymenttoggle(true);
                            }}
                            className="text-sm  text-white PoppinsRegular "
                          >
                            Upload Payment Slip
                          </p>
                        </div>
                      ) : null}
                      {(user.usertype == "Supervisor" &&
                        user?.editaccess == true) ||
                      user.usertype == "Admin" ||
                      user.usertype == "SuperAdmin" ? (
                        <div className="px-[20px] py-[5px] bg-themeblue rounded-md  hover:cursor-pointer hover:bg-themeblue/80">
                          <p
                            onClick={() => {
                              navigate("/dashboard", {
                                state: {
                                  employeedata: employeedata,
                                },
                              });
                            }}
                            className="text-sm  text-white PoppinsRegular "
                          >
                            Edit
                          </p>
                        </div>
                      ) : null}
                      {employeedata?.disabled && (
                        <div className="px-[20px] py-[5px] bg-themeblue rounded-md  hover:cursor-pointer hover:bg-themeblue/80 ml-[10px]">
                          <p
                            onClick={() => {
                              deleteeemployee(employeedata);
                            }}
                            className="text-sm  text-white PoppinsRegular "
                          >
                            Delete
                          </p>
                        </div>
                      )}
                      {employeecheckindata?.length > 0 && !user?.clientrole && (
                        <div className="px-[20px] py-[5px] bg-themeblue rounded-md ml-[10px] hover:cursor-pointer hover:bg-themeblue/80">
                          <p
                            onClick={() => handleDownloadExcelEmployeeData()}
                            className="text-sm  text-white PoppinsRegular "
                          >
                            Export
                          </p>
                        </div>
                      )}
                    </div>
                    <div className="flex flex-col items-center w-full">
                      <img
                        loading="lazy"
                        src={employeedata?.profilepicture}
                        className="w-[130px] h-[130px] rounded-full object-cover  bg-cardOverlay  drop-shadow-lg"
                      />
                      {employeedata ? (
                        <div className="flex flex-col text-center pt-2 w-full">
                          <p className="text-white PoppinsRegular font-bold text-xl">
                            {employeedata?.firstname +
                              " " +
                              employeedata?.lastname}
                          </p>
                          <p className="text-white/60 PoppinsRegular  text-sm">
                            {employeedata?.clientrole
                              ? "Client"
                              : employeedata?.designation}
                          </p>
                          <p className="text-white/60 PoppinsRegular  text-sm">
                            {String(employeedata.employeeid).padStart(4, "0")}
                          </p>

                          {(user.usertype == "Supervisor" &&
                            user?.editaccess == true) ||
                          user.usertype == "Admin" ||
                          user.usertype == "SuperAdmin" ? (
                            <p
                              className={`${
                                employeedata?.leaves > 0
                                  ? "text-themegreen"
                                  : "text-red-500"
                              } PoppinsRegular  text-sm`}
                            >
                              {`Available Leaves: ${employeedata?.leaves}`}
                            </p>
                          ) : null}
                          {DiabledDate()}
                          {SupervisorPermissions()}
                        </div>
                      ) : (
                        <div className="flex flex-col text-center pt-2">
                          <p className="text-white PoppinsRegular font-bold text-xl">
                            {"No User Found"}
                          </p>
                        </div>
                      )}
                    </div>
                  </div>
                  {(user.usertype == "Supervisor" && user?.reportaccess) ||
                  user.usertype == "Admin" ||
                  user.usertype == "SuperAdmin" ? (
                    <>
                      <div className="w-[90%] lg:w-[95%] mx-auto flex flex-row flex-wrap justify-between items-center">
                        <div className="w-full lg:w-[32%] relative">
                          <p className="PoppinsRegular  text-white text-sm pb-1">
                            Select Project
                          </p>
                          <div
                            onClick={() =>
                              setprojectselectionpopup(!projectselectionpopup)
                            }
                            className="px-4 text-white text-sm  PoppinsRegular w-full py-[10px] rounded-xl  items-center flex bg-themelightblack  bg-cardOverlay  drop-shadow-lg"
                          >
                            {project == "" ? "Select Project" : project.title}
                          </div>

                          <ProjectPopUp
                            style={{ top: "80px" }}
                            visible={projectselectionpopup}
                            data={clients}
                            activateoutsidecontainerclick={() => {
                              setprojectselectionpopup(false);
                            }}
                            onClickcorrect={(item) => {
                              dispatch({
                                type: actionType.SELECTPROJECT,
                                payload: item,
                              });
                              let data = { ...item };
                              if (data?.designation?.length > 0) {
                                for (const key in data.designation) {
                                  data.designation[key]["selected"] = false;
                                }
                              }

                              setdesignation(data.designation);
                            }}
                          />
                        </div>

                        <div className="w-full lg:w-[32%] mt-4 lg:mt-0">
                          <p className="PoppinsRegular  text-white text-sm pb-1">
                            From
                          </p>
                          <DatePicker
                            className="input border-none PoppinsRegular rounded-xl w-full bg-themelightblack  bg-cardOverlay  drop-shadow-lg text-white"
                            selected={startdate}
                            onChange={(date) => {
                              dispatch({
                                type: actionType.STARTDATE,
                                payload: new Date(date.setHours(0, 0, 0, 0)),
                              });
                            }}
                          />
                        </div>
                        <div className="w-full lg:w-[32%] mt-4 lg:mt-0">
                          <p className="PoppinsRegular  text-white/80 text-sm pb-1">
                            To
                          </p>
                          <DatePicker
                            className="input  border-none PoppinsRegular   rounded-xl w-full bg-themelightblack  bg-cardOverlay  drop-shadow-lg text-white"
                            selected={enddate}
                            onChange={(date) => {
                              dispatch({
                                type: actionType.ENDDATE,
                                payload: new Date(
                                  date.setHours(23, 59, 59, 59),
                                ),
                              });
                            }}
                          />
                        </div>
                      </div>
                      <div className="w-[90%] lg:w-[95%] mx-auto flex flex-row flex-wrap justify-between items-center">
                        <div className="overflow-x-auto rounded-lg bg-themelightblack  bg-cardOverlay  drop-shadow-lg my-5 w-full ">
                          <table className="max-w-full divide-y divide-white/20  bg-themelightblack text-sm ">
                            <thead className="ltr:text-left rtl:text-right">
                              <tr>
                                <th className="whitespace-nowrap py-2  PoppinsRegular text-white"></th>
                                <th className="whitespace-nowrap py-2  PoppinsRegular text-white">
                                  Date
                                </th>
                                <th className="whitespace-nowrap py-2  PoppinsRegular text-white">
                                  Checkin Time
                                </th>
                                <th className="whitespace-nowrap py-2  PoppinsRegular text-white">
                                  Checkout Time
                                </th>
                                <th className="whitespace-nowrap py-2  PoppinsRegular text-white">
                                  Hours Worked
                                </th>
                                <th className="whitespace-nowrap py-2  PoppinsRegular text-white">
                                  Checkin Location
                                </th>
                                <th className="whitespace-nowrap py-2  PoppinsRegular text-white">
                                  Checkout Location
                                </th>
                              </tr>
                            </thead>
                            <tbody className="text-center">
                              {employeecheckindata.map((item, index) => (
                                <tr
                                  key={index.toString()}
                                  className="hover:bg-[#0989B826]/10 cursor-pointer"
                                >
                                  <td className="whitespace-nowrap px-4 py-2 PoppinsRegular">
                                    <MdEditDocument
                                      onClick={() => {
                                        navigate("/UpdateSlot", {
                                          state: {
                                            edit: true,
                                            editdoc: item,
                                            projectid: item.projectid,
                                            employeedata: employeedata,
                                            projectdesignation:
                                              item.projectdesignation,
                                          },
                                        });
                                      }}
                                      className="text-lighttextGray hover:text-themegreen w-[17px] h-[17px] hover:cursor-pointer"
                                    />
                                  </td>
                                  <td className="whitespace-nowrap px-4 py-2 PoppinsRegular text-white">
                                    {moment(item.checkindate).format(
                                      "DD-MM-YYYY",
                                    )}
                                  </td>
                                  <td className="whitespace-nowrap px-4 py-2 PoppinsRegular">
                                    {item.checkintime ? (
                                      <span className="text-white">
                                        {item.checkintime}
                                      </span>
                                    ) : (
                                      <span className="text-white/40">
                                        Not Available
                                      </span>
                                    )}
                                  </td>
                                  <td className="whitespace-nowrap px-4 py-2 PoppinsRegular">
                                    {item.checkouttime ? (
                                      <span className="text-white">
                                        {item.checkouttime}
                                      </span>
                                    ) : (
                                      <span className="text-white/40">
                                        Not Available
                                      </span>
                                    )}
                                  </td>
                                  <td className="whitespace-nowrap px-4 py-2 PoppinsRegular">
                                    {item?.minutes ? (
                                      <span className="text-themegreen">
                                        {parseInt(item?.minutes / 60) +
                                          " hrs " +
                                          parseInt(item?.minutes % 60) +
                                          " mins"}
                                      </span>
                                    ) : (
                                      <span className="text-white/40">NA</span>
                                    )}
                                  </td>
                                  <td
                                    className="whitespace-nowrap px-4 py-2 PoppinsRegular"
                                    onClick={() => {
                                      if (item?.checkinlatitude) {
                                        getlocationaddress(
                                          item?.checkinlatitude,
                                          item?.checkinlongitude,
                                        );
                                      }
                                    }}
                                  >
                                    {item?.checkinlatitude ? (
                                      <span className="text-white cursor-pointer hover:underline">
                                        View
                                      </span>
                                    ) : (
                                      <span className="text-white/40">
                                        Not Available
                                      </span>
                                    )}
                                  </td>
                                  <td
                                    className="whitespace-nowrap px-4 py-2 PoppinsRegular"
                                    onClick={() => {
                                      if (item?.checkoutlatitude) {
                                        getlocationaddress(
                                          item?.checkoutlatitude,
                                          item?.checkoutlongitude,
                                        );
                                      }
                                    }}
                                  >
                                    {item?.checkoutlatitude ? (
                                      <span className="text-white cursor-pointer hover:underline">
                                        View
                                      </span>
                                    ) : (
                                      <span className="text-white/40">
                                        Not Available
                                      </span>
                                    )}
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </>
                  ) : null}

                  {(user.usertype == "Supervisor" &&
                    user?.editaccess == true) ||
                  user.usertype == "Admin" ||
                  user.usertype == "SuperAdmin" ? (
                    <>
                      {employeedata && (
                        <div className="w-[90%] lg:w-[95%] mx-auto  mb-[10px]">
                          {disableloader ? (
                            <div className=" py-4  mt-6  w-full flex justify-center  ">
                              <RotatingLines
                                visible={true}
                                height="25"
                                width="25"
                                color="grey"
                                strokeColor="#FF0000"
                                strokeWidth="5"
                                animationDuration="0.75"
                                ariaLabel="rotating-lines-loading"
                                wrapperStyle={{}}
                                wrapperClass=""
                              />
                            </div>
                          ) : (
                            <button
                              onClick={() => {
                                setemployeedeletionconfirmation(true);
                              }}
                              type="submit"
                              className={`text-center py-4 rounded-lg  ${
                                employeedata?.disabled
                                  ? "bg-themegreen hover:bg-themegreen/80"
                                  : "bg-red-600 hover:bg-red-600/80"
                              } w-full  mx-auto text-white text-sm  PoppinsRegular `}
                            >
                              {employeedata?.disabled
                                ? "Enable Employee"
                                : "Disable Employee"}
                            </button>
                          )}
                        </div>
                      )}
                    </>
                  ) : null}
                </div>
              )}
            </div>
          </div>
        ) : null
        //         <div className=' border border-bordercolor rounded-xl mb-20   bg-white  drop-shadow-lg md:mx-[30px] '>
        //           {generalemployeecheckindata?.length > 0 &&
        //             <div
        //               className='download-table-xls-button'>
        //               <p
        //                 onClick={() => handleDownloadExcelGeneral()}
        //                 className='text-sm  download-text PoppinsRegular  bg-themeColor'>Export</p>
        //             </div>
        //           }

        //           <div className='mt-[30px] lg:mt-10'>

        //             {/* <div className='w-[95%] mx-auto mt-5 lg:mt-10'>
        // <div className="grid grid-cols-2 gap-4 md:grid-cols-4 lg:gap-8">

        // <div className="flex flex-col items-center justify-center rounded-lg bg-gray-100 p-4 lg:p-8  bg-cardOverlay  drop-shadow-lg">
        // <p className="text-base text-white PoppinsRegular  md:text-lg">Today's Work</p>
        // <div className="text-sm  text-white/50 PoppinsRegular">{todayshours + " hrs"}</div>
        // </div>

        // <div className="flex flex-col items-center justify-center rounded-lg bg-gray-100 p-4 md:p-8  bg-cardOverlay  drop-shadow-lg">
        // <div className="text-base text-white PoppinsRegular  md:text-lg">Weeks's Work</div>
        // <div className="text-sm  text-white/50 PoppinsRegular">{weeklyhours + " hrs"}</div>
        // </div>

        // <div className="flex flex-col items-center justify-center rounded-lg bg-gray-100 p-4 md:p-8  bg-cardOverlay  drop-shadow-lg">
        // <div className="text-base text-white PoppinsRegular  md:text-lg">Months's Work</div>
        // <div className="text-sm  text-white/50 PoppinsRegular">{monthlyhours + " hrs"}</div>
        // </div>

        // <div className="flex flex-col items-center justify-center rounded-lg bg-gray-100 p-4 md:p-8  bg-cardOverlay  drop-shadow-lg">
        // <div className="text-base text-white PoppinsRegular  md:text-lg">Total Work Time</div>
        // <div className="text-sm  text-white/50 PoppinsRegular">{alltimehours + " hrs"}</div>
        // </div>

        // </div>
        // </div> */}
        //             {/* <div className='flex w-full items-center justify-center my-12'>
        // <div className='flex flex-col items-center'>
        // <img loading="lazy" src={employeedata?.profilepicture} className='w-[130px] h-[130px] rounded-full object-cover  bg-cardOverlay  drop-shadow-lg' />
        // <div className='flex flex-col text-center pt-2'>
        // <text className='text-white PoppinsRegular font-bold text-xl'>{employeedata?.firstname + " " + employeedata?.lastname}</text>
        // <text className='text-white/60 PoppinsRegular  text-sm'>{employeedata?.designation}</text>
        // </div>
        // </div>
        // </div> */}

        //             <div className='w-[90%] lg:w-[95%] mx-auto flex flex-row flex-wrap justify-between items-center'>

        //               <div
        //                 className='w-full lg:w-[24%]'>

        //                 <div
        //                   className='flex flex-row items-end justify-between pb-1'>
        //                   <p className='PoppinsRegular  text-white/80 text-sm '>Select Project</p>
        //                   {project != "" && <p
        //                     onClick={() => {

        //                       setproject("")
        //                       setdesignation([])

        //                     }}
        //                     className='ml-[5px] text-[13px] text-red-600 cursor-pointer hover:underline'>Clear</p>}
        //                 </div>
        //                 <div
        //                   onClick={() => setprojectselectionpopup(!projectselectionpopup)}
        //                   className="px-4 text-white text-sm  PoppinsRegular w-full py-[10px] rounded-xl border border-themeColor items-center flex">{project == "" ? "Select Project" : project.title}</div>
        //                 {projectselectionpopup &&
        //                   <div
        //                   ref ={projectselectionpopupref}
        //                   className='w-[250px] max-h-[150px] bg-white border border-bordercolor rounded-md overflow-y-scroll gk-scr p-[10px] position absolute z-10 mt-1'>
        //                     {clients.map((item, index) =>
        //                     (

        //                       <div
        //                       key = {index.toString()}
        //                         onClick={() => {
        //                           setproject(item)
        //                           let data = { ...item }
        //                           if (data?.designation?.length > 0) {
        //                             for (const key in data.designation) {
        //                               data.designation[key]["selected"] = false
        //                             }
        //                           }

        //                           setdesignation(data.designation)
        //                           setprojectselectionpopup(false)
        //                         }}
        //                         className={`flex flex-row items-center  w-full py-[5px] cursor-pointer hover:bg-themeColor hover:text-white text-white hover:px-[10px] hover:rounded-xl`}>
        //                         <img loading="lazy" src={item.logo} className='w-[25px] h-[25px] rounded-full object-cover' />
        //                         <p className='  PoppinsRegular text-sm ml-[10px]'>{item.title}</p>
        //                       </div>
        //                     ))}
        //                   </div>}
        //               </div>
        //               {project != "" && designation?.length > 0 &&
        //                 <div

        //                   className='w-full lg:w-[24%]'>

        //                   <div

        //                     className='flex flex-row items-end justify-between pb-1 mt-4 lg:mt-0'>
        //                     <p className='PoppinsRegular  text-white/80 text-sm '>Designation</p>
        //                     {designation?.length > 0 && <p
        //                       onClick={() => {

        //                         setdesignation([])

        //                       }}
        //                       className='ml-[5px] text-[13px] text-red-600 cursor-pointer hover:underline'>Clear</p>}
        //                   </div>

        //                   <div

        //                     onClick={() => setdesignationselectionpopup(!designationselectionpopup)}
        //                     className="px-4 text-white text-sm  PoppinsRegular w-full py-[10px] rounded-xl border border-themeColor items-center flex flex-wrap" >{designation?.length == 0 || designation.find(data => data.selected == true) == undefined ? "Select Designation" : designation.filter(function (data) { return data.selected == true }).map(function (data) {
        //                       return <div
        //                         onClick={() => {
        //                           let dataset = [...designation]
        //                           const designationindex = dataset.findIndex(item => item.designation === data.designation);
        //                           dataset[designationindex].selected = false
        //                           setdesignation(dataset)
        //                         }}
        //                         className='bg-themeColor px-[5px] py-[1px] mr-[5px] rounded-md flex flex-row items-center mb-[2px]'><text className='text-white '>{data.designation}</text>
        //                         <IoIosCloseCircle

        //                           className=" text-white ml-[3px]  w-[15px] h-[15px] hover:cursor-pointer"
        //                         /></div>
        //                     })}

        //                   </div>
        //                   {designationselectionpopup &&
        //                     <div
        //                     ref={designationselectionpopupref}
        //                     className='w-[250px] max-h-[150px] bg-white border border-bordercolor rounded-md overflow-y-scroll gk-scr p-[10px] position absolute z-10 mt-1'>
        //                       {designation.map((item, index) =>
        //                       (

        //                         <div
        //                         key = {index.toString()}
        //                           onClick={() => {
        //                             let data = [...designation]
        //                             data[index].selected = !data[index].selected
        //                             //         data.designation[index].selected = !data.designation[index].selected
        //                             // setproject(data)

        //                             setdesignation(data)
        //                           }}
        //                           className={` flex flex-row items - center justify - between w - full py - [5px] cursor - pointer hover: bg - themeColor hover: text - white text - textcolor hover: px - [10px] hover: rounded - xl`}>
        //                           <p className='  PoppinsRegular text-sm ml-[10px]'>{item.designation}</p>
        //                           {item.selected &&
        //                             <IoCheckmarkCircle

        //                               className="   w-[20px] h-[20px]"
        //                             />

        //                           }

        //                         </div>
        //                       ))}
        //                     </div>}

        //                 </div>
        //               }
        //               <div className='w-full lg:w-[24%] mt-4 lg:mt-0'>
        //                 <p className='PoppinsRegular  text-white/80 text-sm pb-1'>From</p>
        //                 <DatePicker className='PoppinsRegular  border border-themeColor rounded-xl w-full' selected={startdate} onChange={(date) => setstartdate(new Date(date.setHours(0, 0, 0, 0)))} />
        //               </div>
        //               <div className='w-full lg:w-[24%] mt-4 lg:mt-0'>
        //                 <p className='PoppinsRegular  text-white/80 text-sm pb-1'>To</p>
        //                 <DatePicker className='PoppinsRegular  border border-themeColor rounded-xl w-full' selected={enddate} onChange={(date) => setenddate(date)} />
        //               </div>
        //             </div>
        //             <div className='w-[90%] lg:w-[95%] mx-auto flex flex-row flex-wrap justify-between items-center'>
        //               <div className="overflow-x-auto rounded-lg border border-bordercolor my-5 w-full ">
        //                 <table className="max-w-full divide-y-2 divide-gray-200 bg-white text-sm ">
        //                   <thead className="ltr:text-left rtl:text-right">
        //                     <tr>
        //                       <th className="whitespace-nowrap py-2  PoppinsRegular text-white px-4 "></th>
        //                       <th className="whitespace-nowrap py-2  PoppinsRegular text-white px-4 ">Date</th>
        //                       <th className="whitespace-nowrap py-2  PoppinsRegular text-white px-10 "></th>
        //                       {/* <th className="whitespace-nowrap py-2  PoppinsRegular text-white px-4 ">Employee ID</th> */}
        //                       <th className="whitespace-nowrap py-2  PoppinsRegular text-white px-4 ">Employee Name</th>
        //                       <th className="whitespace-nowrap py-2  PoppinsRegular text-white px-4 ">Designation</th>
        //                       <th className="whitespace-nowrap py-2  PoppinsRegular text-white px-4 ">Checkin Time</th>
        //                       <th className="whitespace-nowrap py-2  PoppinsRegular text-white px-4 ">Checkout Time</th>
        //                       <th className="whitespace-nowrap py-2  PoppinsRegular text-white px-4 ">Hours Worked</th>
        //                       <th className="whitespace-nowrap py-2  PoppinsRegular text-white px-4 ">Checkin Location</th>
        //                       <th className="whitespace-nowrap py-2  PoppinsRegular text-white px-4 ">Checkout Location</th>
        //                     </tr>
        //                   </thead>
        //                   <tbody className="divide-y divide-gray-200 text-center w-full">
        //                     {loading ?
        //                       <div
        //                         className=' py-10  w-full   flex items-center justify-center absolute'>
        //                         <RotatingLines
        //                           visible={true}
        //                           height="25"
        //                           width="25"
        //                           strokeColor="#00C763"

        //                           strokeWidth="5"
        //                           animationDuration="0.75"
        //                           ariaLabel="rotating-lines-loading"
        //                           wrapperStyle={{}}
        //                           wrapperClass=""
        //                         />
        //                       </div>
        //                       :

        //                       generalemployeecheckindata.map((item, index) => (
        //                         designation.find(data => data.selected == true) == undefined || designation.find(data => data.selected == true && item.projectdesignation == data.designation) != undefined ?
        //                           <tr
        //                           key = {index.toString()}
        //                           className='hover:bg-[#0989B826]/10 cursor-pointer'>
        //                             <td
        //                               className="whitespace-nowrap px-4 py-2 PoppinsRegular  ">
        //                               <MdEditDocument
        //                                 onClick={() => {

        //                                   navigate('/UpdateSlot', {
        //                                     state: {
        //                                       edit: true,
        //                                       editdoc: item,
        //                                       projectid: item.projectid,
        //                                       employeedata: employeedata,
        //                                       projectdesignation: item.projectdesignation,

        //                                     }
        //                                   });

        //                                 }}
        //                                 className=" text-lighttextGray hover:text-themegreen   w-[17px] h-[17px] hover:cursor-pointer"
        //                               />
        //                             </td>
        //                             <td className="whitespace-nowrap px-4 py-2 PoppinsRegular  text-white">
        //                               {moment(item.checkindate).format("DD-MM-YYYY")}
        //                             </td>
        //                             <td className="whitespace-nowrap px-4 py-2 PoppinsRegular  text-white flex justify-center ">
        //                               <img loading="lazy" src={item.profilepicture} className='w-[35px] h-[35px]  object-cover rounded-full' />
        //                             </td>
        //                             {/* <td className="whitespace-nowrap px-4 py-2 PoppinsRegular  text-white">
        //       {item.employeeid}
        //     </td> */}

        //                             <td className="whitespace-nowrap px-4 py-2 PoppinsRegular  text-white">
        //                               {item.name}
        //                             </td>
        //                             <td className="whitespace-nowrap px-4 py-2 PoppinsRegular  text-white  ">
        //                               {item.projectdesignation}
        //                             </td>
        //                             <td className="whitespace-nowrap px-4 py-2 PoppinsRegular  text-white">
        //                               {item.checkintime ? item.checkintime : "Not Available"}
        //                             </td>
        //                             <td className="whitespace-nowrap px-4 py-2 PoppinsRegular  text-white">
        //                               {item.checkouttime ? item.checkouttime : "Not Available"}
        //                             </td>
        //                             <td className="whitespace-nowrap px-4 py-2 PoppinsRegular  text-white">
        //                               {item?.minutes ? parseInt(item?.minutes / 60) : 0}
        //                             </td>
        //                             <td className="whitespace-nowrap px-4 py-2 PoppinsRegular  text-white"
        //                               onClick={() => {
        //                                 getlocationaddress(item?.checkinlatitude, item?.checkinlongitude)
        //                               }}>
        //                               {item?.checkinlatitude ? "View" : "Not Available"}
        //                             </td>
        //                             <td className="whitespace-nowrap px-4 py-2 PoppinsRegular  text-white"
        //                               onClick={() => {
        //                                 getlocationaddress(item?.checkoutlatitude, item?.checkoutlongitude)
        //                               }}>
        //                               {item?.checkoutlatitude ? "View" : "Not Available"}
        //                             </td>
        //                           </tr>
        //                           : null
        //                       ))
        //                     }
        //                   </tbody>
        //                 </table>
        //               </div>
        //             </div>

        //           </div>

        //         </div>
      }
    </div>
  );
}

export default HoursWorked;
